// Debounced Nominatim address search (India-scoped, no API key).
import { useCallback, useEffect, useRef, useState } from "react";

export default function useAddressSearch() {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  const onQueryChange = useCallback((v) => {
    setQuery(v);
    if (timer.current) clearTimeout(timer.current);
    if (!v.trim()) { setSuggestions([]); return; }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const url = `https://nominatim.openstreetmap.org/search?format=json&countrycodes=in&limit=6&q=${encodeURIComponent(v)}`;
        const res = await fetch(url, { headers: { "Accept-Language": "en" } });
        const data = await res.json();
        setSuggestions(data);
      } catch (err) {
        console.error("Nominatim search failed", err);
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    }, 400);
  }, []);

  const clear = useCallback(() => { setQuery(""); setSuggestions([]); }, []);

  return { query, setQuery, suggestions, setSuggestions, loading, onQueryChange, clear };
}
